/**
 * Component to render the stars product taste etc
 * Tricky bit in here is the number of stars. We have a float coming in
 * so check if it has a .5 on end or not. Then make an array of the size of whole stars
 * to iterate over inserting a star. Add the half if needed
 */

import { mergeStyles } from '@bulknutrients/bulk-shared-lib/utils';
import { Icons } from '@components/Icons/Icons';

export function StarRating({ rating, size = 13, className = '' }) {
  const half = rating % 1 !== 0;
  const whole = Math.floor(rating);
  const empty = 5 - whole - +half;

  return (
    <span className={mergeStyles(className, 'flex items-center text-orange')}>
      {Array.apply(null, Array(whole))
        .map(() => {})
        .map((a, i) => (
          <Icons.Star.Full key={`star${i}`} size={size} />
        ))}
      {half && <Icons.Star.Half size={size} />}
      {empty > 0 &&
        Array.apply(null, Array(empty))
          .map(() => {})
          .map((a, i) => (
            <Icons.Star.Outline key={`emptystar${i}`} size={size} />
          ))}
    </span>
  );
}
